import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { PortalService } from 'app/area-cliente/portal/portal.service';

@Component({
  selector: 'cabecalho-portal',
  templateUrl: './cabecalho.component.html',
  styleUrls: ['./cabecalho.component.scss']
})
export class CabecalhoComponent implements OnInit {

  @Input('fantasia') fantasia: String;

  @Output() toogleMenu = new EventEmitter();

  isSuporteSelecionado: boolean = false;
  isAjudaSelecionado: boolean = false;
  isBoletoSelecionado: boolean = false;
  isNoticiasSelecionado: boolean = false;

  constructor(public servicePortal: PortalService) { }

  ngOnInit() {

    var url_atual = window.location.hash;
    url_atual = url_atual.replace('#/', '');
    this.clickNavBar(url_atual.split('/')[0]);
  }

  menuOnClick(evento) {
    this.toogleMenu.emit(evento);
    event.stopPropagation();
  }

  clickNavBar(navSelecionada: String) {
    if (navSelecionada === "suporte") {
      this.isBoletoSelecionado = false;
      this.isSuporteSelecionado = true;
      this.isAjudaSelecionado = false;
      this.isNoticiasSelecionado = false;
    } else if (navSelecionada === "ajuda") {
      this.isBoletoSelecionado = false;
      this.isSuporteSelecionado = false;
      this.isAjudaSelecionado = true;
      this.isNoticiasSelecionado = false;
    } else if (navSelecionada === "boleto") {
      this.isBoletoSelecionado = true;
      this.isSuporteSelecionado = false;
      this.isAjudaSelecionado = false;
      this.isNoticiasSelecionado = false;
    } else if (navSelecionada === "noticias") {
      this.isBoletoSelecionado = false;
      this.isSuporteSelecionado = false;
      this.isAjudaSelecionado = false;
      this.isNoticiasSelecionado = true;
    } else if (navSelecionada.length > 0) {
      this.isBoletoSelecionado = true;
      this.isSuporteSelecionado = false;
      this.isAjudaSelecionado = false;
      this.isNoticiasSelecionado = false;
    } else {
      this.isBoletoSelecionado = false;
      this.isSuporteSelecionado = true;
      this.isAjudaSelecionado = false;
      this.isNoticiasSelecionado = false;
    }
  }
}



// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/layout/componentes-ui/cabecalho/cabecalho.component.ts